// ILegalTransactionMeetingEmail.ts
import { z } from 'zod';
import { documentSchema } from './IDocument';

export const legalTransactionMeetingEmailSchema = z
  .object({
    idLegalTransactionMeetingEmail: z.number().default(-1),
    idLegalTransactionMeeting: z.number().default(-1),
    idLegalTransaction: z.number().default(-1),
    Title: z.string().default(''),
    Subject: z.string().default(''),
    Body: z.string().default(''),
    allowDataUpload: z.coerce.boolean().default(false),
    sendOnCreation: z.coerce.boolean().default(false),
    sendOnCancelling: z.coerce.boolean().default(false),
    sendOnReschedule: z.coerce.boolean().default(false),
    sendWithCalenderFile: z.coerce.boolean().default(false),
    DaysBeforeDate: z.number().nullable().default(null),
  })
  .extend({
    Documents: z.array(documentSchema).default([]),
  });

export type ILegalTransactionMeetingEmail = z.infer<
  typeof legalTransactionMeetingEmailSchema
>;
